import React, { useState } from 'react';
import { Button, DatePicker, Divider, Drawer, Form, Input, Row, Select, Space } from 'antd';
import { fetchData } from '../../service/dataServices';
import { Option } from 'antd/es/mentions';

const { RangePicker } = DatePicker;

const FilterDrawer = ({drawerVisible, setDrawerVisible, setFilters, filters}) => {
  const [form] = Form.useForm();
  const [dropdowns, setDropdowns] = useState();
  fetchData('/api/dropdowns', setDropdowns);

  const onFinish = (values) => {
    setFilters(prevState => ({
      ...prevState,
      ...values,
      page: 0,
      startDate: values.date && values.date[0] ? values.date[0].format("YYYY-MM-DD") : undefined,
      endDate: values.date && values.date[1] ? values.date[1].format("YYYY-MM-DD") : undefined,
      date: undefined,
    }));
  }

  const getDropdownOptions = (type) => {
    if (dropdowns) {
      return dropdowns[type];
    }
    return [];
  };

  const getSelectFormItem = (type, label, multiple = false) => {
    return (
      <Form.Item label={label} name={type}>
        <Select placeholder={`Select ${label || type}`} mode={multiple ? 'tags' : false} allowClear>
          {
            getDropdownOptions(type).map(option => (
              <Option value={option.id} key={option.id}>{option.title}</Option>
            ))
          }
        </Select>
      </Form.Item>
    );
  };

  const getDropdownFormItem = (type, label) => {
    return getSelectFormItem(type, label);
  };

  const getInputFormItem = (name, label, required = false) => (
    <Form.Item
      label={label}
      name={name}
      rules={required ? [{ required: true, message: `${label} is required!` }] : []}
    >
      <Input placeholder={label} allowClear/>
    </Form.Item>
  );

  const getDatePickerFormItem = (name, label) => (
    <Form.Item
      label={label}
      name={name}
    >
      <RangePicker />
    </Form.Item>
  )

  const onClear = () => {
    form.resetFields();
    setFilters({
      page: 0,
      size: 10,
    });
  }

  return (
    <Drawer
      title="Filters"
      placement="right"
      size="large"
      onClose={() => setDrawerVisible(false)}
      visible={drawerVisible}
      destroyOnClose
    >
      <Form
        // name="basic"
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 12 }}
        onFinish={onFinish}
        autoComplete="off"
        initialValues={filters}
      >


        {getInputFormItem("inventoryNumber", "Inventory Number")}
        {getInputFormItem("objectName", "Object Name")}
        {getInputFormItem("objectTitle", "Object Title")}
        {getDropdownFormItem('classification', 'Classification')}
        {getDropdownFormItem('category', 'Category')}
        {getInputFormItem("country", "Country")}
        {getInputFormItem("description", "Description")}
        {getInputFormItem("showcaseNumber", "Showcase Number")}
        {getDropdownFormItem('location', 'Location')}
        {getInputFormItem('century', 'Century')}
        {getDatePickerFormItem('date', 'Date')}

        <Divider/>
        <Row justify="center">
          <Space align="center">
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button onClick={onClear}>
              Clear
            </Button>
          </Space>
        </Row>
      </Form>
    </Drawer>
  );
};

export default FilterDrawer;
